const Cookies = require('js-cookie')

$('[data-alternating]').each((_, el) => {
  const $el = $(el)
  const key = $el.attr('data-alternating')
  const lastSeen = $el.attr('data-alternating-index')

  Cookies.set(key, lastSeen, { expires: 14, path: '/' })
})
